import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex gap-3 md:hidden" }
const _hoisted_2 = { class: "text-md font-bold" }
const _hoisted_3 = { class: "flex flex-col gap-1.5 min-w-0 flex-1" }
const _hoisted_4 = { class: "text-left text-sm font-medium" }
const _hoisted_5 = { class: "text-left text-xs text-gray-400 truncate" }
const _hoisted_6 = {
  key: 0,
  class: "text-left"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-gray-400" }, "Telefone: ", -1)
const _hoisted_8 = { class: "text-xs text-gray-600" }
const _hoisted_9 = {
  key: 1,
  class: "text-left"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-gray-400 block mb-0.5" }, "Empresas", -1)
const _hoisted_11 = { class: "flex items-center gap-1 pt-1" }
const _hoisted_12 = { class: "hidden md:flex md:col-span-4 lg:col-span-3 items-center gap-3" }
const _hoisted_13 = { class: "text-md font-bold" }
const _hoisted_14 = { class: "text-left" }
const _hoisted_15 = { class: "lg:block hidden lg:col-span-3" }
const _hoisted_16 = { class: "text-left truncate ..." }
const _hoisted_17 = { class: "text-left lg:block hidden lg:col-span-2" }
const _hoisted_18 = { class: "lg:block hidden lg:col-span-2" }
const _hoisted_19 = { class: "hidden md:block md:col-span-2 lg:col-span-2" }
const _hoisted_20 = { class: "flex items-center justify-around flex-nowrap" }
const _hoisted_21 = { class: "grid grid-cols-1 xl:grid-cols-4 lg:grid-cols-3 gap-4 pb-6 my-0" }

import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'
import DsSwitch from '@/components/designSystem/Switch/index.vue'
import { computed, reactive, ref } from 'vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import Input from '../Inputs/Input.vue'
import Network from '@/Network'
import { CompanyUserResponse } from '@/Network/Types/Responses/CompanyResponses'
import { useToast } from 'vue-toastification'
import { useErrorToast } from '@/composables/useErrorToast'
import TableChips from '@/components/designSystem/Chips/TableChips.vue'
import { mdiLockReset, mdiPencil, mdiShieldAccount } from '@mdi/js'
import { EModals, useModalStore } from '@/pinia-store/useModalStore'
import { usePermissionsStore } from '@/pinia-store/usePermissionsStore'
import { AuthorizationPermissions, AuthorizationResourcesAndSubjects } from '@/types/authorization'
import ProtectedAvatar from '@/components/designSystem/AvatarUser/ProtectedAvatar.vue'
import { resolveAvatarSrc } from '@/utils/avatar'
import { formatPhone } from '@/utils/formatters'


export default /*#__PURE__*/_defineComponent({
  __name: 'TableUsers',
  props: {
    data: {}
  },
  emits: ['edit-user'],
  setup(__props: any, { emit }) {

const props = __props;



const resolvedAvatar = computed(() => resolveAvatarSrc(props.data.user.avatarUrl))

const loadingToggle = ref(false)
const isErrorPassword = ref(false)
const isErrorConfirmPassword = ref(false)
const isValid = ref(false)
const loading = ref(false)
const toast = useToast()
const { notifyError } = useErrorToast()


const permissionsStore = usePermissionsStore()
const modalStore = useModalStore()

const emitEditUser = () => {
  const payload = {
    user: props.data.user,
    companies: props.data.companies
  }
  emit('edit-user', payload)
}

const handleOpenPermissions = () => {
  modalStore.toggleModal(EModals.PERMISSIONS_TREE, {
    subjectId: props.data.user.id,
    subjectType: AuthorizationResourcesAndSubjects.User,
    subjectName: props.data.user?.name
  })
}

const form = reactive({
  radio: 'Dashboard',
  checkbox: false,
  newPassword: '',
  confirmPassword: ''
})

function validatePassword() {
  const regex = new RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[$*&@#])[0-9a-zA-Z$*&@#]{8,}$/)
  if (form.newPassword === '' || !regex.test(form.newPassword)) {
    isValid.value = false
    isErrorPassword.value = true
  } else {
    isValid.value = true
    isErrorPassword.value = false
  }
}

function validateConfirmPassword() {
  const isEqualPasswords = form.confirmPassword === form.newPassword

  if (form.confirmPassword === '') {
    isValid.value = false
    isErrorConfirmPassword.value = true
  } else if (!isEqualPasswords) {
    isValid.value = false
    isErrorConfirmPassword.value = true
  } else {
    isValid.value = true
    isErrorConfirmPassword.value = false
  }
}

const handleSendPassword = async () => {
  if (form.newPassword.length === 0 || form.confirmPassword.length === 0) return
  try {
    loading.value = true
    await Network.company.changeUserCompanyPassword(props.data.user.id, {
      password: form.newPassword,
      confirmPassword: form.confirmPassword
    })
    toast.success(`Usuário ${props.data.user.name} teve a senha atualizada com sucesso!`)

    form.newPassword = ''
    form.confirmPassword = ''
  } catch (error) {
    // Antes: `error.response?.data?.message` extraído na mão — com o `ServiceError`
    // do service migrado o cast deixaria de casar e a mensagem do backend sumiria.
    notifyError(error, 'Não foi possível alterar a senha. Verifique os dados e tente novamente.')
    console.error(error)
  } finally {
    loading.value = false
  }
}

const getInitalsName = (name: string) => {
  return name.substring(0, 2).toUpperCase()
}

const toggleUserStatus = async (user: { id: number; isActive: boolean }, newStatus: boolean) => {
  try {
    loadingToggle.value = true
    await Network.user.toggleUserStatus(user.id, newStatus)
    user.isActive = newStatus
    toast.success(`Usuário ${newStatus ? 'ativado' : 'desativado'} com sucesso!`)
  } catch (error) {
    notifyError(error, 'Não foi possível alterar o status do usuário. Tente novamente.')
    console.error(error)
  } finally {
    loadingToggle.value = false
  }
}

const canUserCreating = computed(() => {
  return permissionsStore.checkAnyRessources({
    permission: AuthorizationPermissions.CompanyUserCreating,
    resourceType: AuthorizationResourcesAndSubjects.Company
  })
})

return (_ctx: any,_cache: any) => {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Disclosure), { as: "div" }, {
      default: _withCtx(({ open }) => [
        _createElementVNode("div", {
          class: _normalizeClass(`flex flex-col gap-2 py-3 px-4 w-full md:grid md:grid-cols-6 lg:grid-cols-12 md:gap-1 md:items-center md:py-2 my-0 hover:bg-gray-50 ${
          open ? '' : 'border-b border-gray-200'
        }`)
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_avatar, {
              color: "primary",
              class: "shrink-0 mt-0.5"
            }, {
              default: _withCtx(() => [
                _createVNode(ProtectedAvatar, {
                  src: resolvedAvatar.value,
                  size: 40
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_2, _toDisplayString(getInitalsName(props.data.user.name || 'ME')), 1)
                  ]),
                  _: 1
                }, 8, ["src"])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_4, _toDisplayString(props.data.user?.name), 1),
                _createElementVNode("p", _hoisted_5, _toDisplayString(props.data.user?.email), 1)
              ]),
              (props.data.user.mainPhone?.phoneNumber)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(formatPhone)(props.data.user.mainPhone.phoneNumber)), 1)
                  ]))
                : _createCommentVNode("", true),
              (props.data.companies?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _hoisted_10,
                    _createVNode(TableChips, {
                      items: props.data.companies
                    }, null, 8, ["items"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_v_tooltip, {
                  text: props.data.user.isActive ? 'Desativar usuário' : 'Ativar usuário'
                }, {
                  activator: _withCtx(({ props: tooltipProps }) => [
                    _createElementVNode("span", _mergeProps(tooltipProps, { class: "inline-flex" }), [
                      _createVNode(DsSwitch, {
                        "model-value": props.data.user.isActive,
                        loading: loadingToggle.value,
                        disabled: !canUserCreating.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = (val) => toggleUserStatus(props.data.user, val))
                      }, null, 8, ["model-value", "loading", "disabled"])
                    ], 16)
                  ]),
                  _: 1
                }, 8, ["text"]),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  density: "compact",
                  color: "primary",
                  icon: _unref(mdiPencil),
                  onClick: emitEditUser,
                  class: "flex-shrink-0",
                  disabled: !canUserCreating.value
                }, null, 8, ["icon", "disabled"]),
                _createVNode(_unref(DisclosureButton), {
                  as: "template",
                  disabled: !canUserCreating.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      variant: "text",
                      density: "compact",
                      color: "primary",
                      icon: _unref(mdiLockReset),
                      class: "flex-shrink-0"
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_v_btn, {
                  "data-testid": "permissions-user-button-mobile",
                  variant: "text",
                  density: "compact",
                  color: "primary",
                  icon: _unref(mdiShieldAccount),
                  onClick: handleOpenPermissions,
                  class: "flex-shrink-0",
                  disabled: !canUserCreating.value
                }, null, 8, ["icon", "disabled"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_v_avatar, {
              color: "primary",
              class: "shrink-0"
            }, {
              default: _withCtx(() => [
                _createVNode(ProtectedAvatar, {
                  src: resolvedAvatar.value,
                  size: 40
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_13, _toDisplayString(getInitalsName(props.data.user.name || 'ME')), 1)
                  ]),
                  _: 1
                }, 8, ["src"])
              ]),
              _: 1
            }),
            _createElementVNode("p", _hoisted_14, _toDisplayString(props.data.user?.name), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("p", _hoisted_16, _toDisplayString(props.data.user?.email), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("p", null, _toDisplayString(_unref(formatPhone)(props.data.user.mainPhone?.phoneNumber)), 1)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(TableChips, {
              items: props.data.companies
            }, null, 8, ["items"])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_v_tooltip, {
                text: props.data.user.isActive ? 'Desativar usuário' : 'Ativar usuário'
              }, {
                activator: _withCtx(({ props: tooltipProps }) => [
                  _createElementVNode("span", _mergeProps(tooltipProps, { class: "inline-flex" }), [
                    _createVNode(DsSwitch, {
                      "model-value": props.data.user.isActive,
                      loading: loadingToggle.value,
                      disabled: !canUserCreating.value,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = (val) => toggleUserStatus(props.data.user, val))
                    }, null, 8, ["model-value", "loading", "disabled"])
                  ], 16)
                ]),
                _: 1
              }, 8, ["text"]),
              _createVNode(_component_v_tooltip, { text: "Editar Dados do Usuário" }, {
                activator: _withCtx(({ props: tooltipProps }) => [
                  _createVNode(_component_v_btn, _mergeProps(tooltipProps, {
                    variant: "text",
                    density: "compact",
                    color: "primary",
                    icon: _unref(mdiPencil),
                    onClick: emitEditUser,
                    class: "ml-1 flex-shrink-0",
                    disabled: !canUserCreating.value
                  }), null, 16, ["icon", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_tooltip, { text: "Redefinir Senha" }, {
                activator: _withCtx(({ props: tooltipProps }) => [
                  _createVNode(_unref(DisclosureButton), {
                    as: "template",
                    disabled: !canUserCreating.value
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, _mergeProps(tooltipProps, {
                        variant: "text",
                        density: "compact",
                        color: "primary",
                        icon: _unref(mdiLockReset),
                        class: "ml-1 flex-shrink-0"
                      }), null, 16, ["icon"])
                    ]),
                    _: 2
                  }, 1032, ["disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_tooltip, { text: "Visualizar permissões" }, {
                activator: _withCtx(({ props: tooltipProps }) => [
                  _createVNode(_component_v_btn, _mergeProps(tooltipProps, {
                    "data-testid": "permissions-user-button",
                    variant: "text",
                    density: "compact",
                    color: "primary",
                    icon: _unref(mdiShieldAccount),
                    onClick: handleOpenPermissions,
                    class: "ml-1 flex-shrink-0",
                    disabled: !canUserCreating.value
                  }), null, 16, ["icon", "disabled"])
                ]),
                _: 1
              })
            ])
          ])
        ], 2),
        _createVNode(_unref(DisclosurePanel), {
          class: _normalizeClass(`w-full py-4 ${open ? 'border-b border-gray-200' : ''}`)
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_21, [
              _createVNode(Input, {
                onChange: _cache[2] || (_cache[2] = () => validatePassword()),
                isError: isErrorPassword.value,
                modelValue: form.newPassword,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.newPassword) = $event)),
                errorMessage: "A senha precisa ter pelo menos 8 caracters, 1 letra maíuscula, 1 caracter especial e 1 número",
                type: "password",
                pattern: "^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[$*&@#])[0-9a-zA-Z$*&@#]{8,}$",
                width: "100%",
                label: "Senha",
                required: ""
              }, null, 8, ["isError", "modelValue"]),
              _createVNode(Input, {
                onChange: _cache[4] || (_cache[4] = () => validateConfirmPassword()),
                isError: isErrorConfirmPassword.value,
                modelValue: form.confirmPassword,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.confirmPassword) = $event)),
                errorMessage: "As senhas não coincidem!",
                type: "password",
                pattern: "^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[$*&@#])[0-9a-zA-Z$*@#]{8,}$",
                width: "100%",
                label: "Senha",
                required: ""
              }, null, 8, ["isError", "modelValue"]),
              _createVNode(OutlineButton, {
                onClick: handleSendPassword,
                width: "100%",
                style: {"max-height":"52px"},
                class: "mr-4",
                text: "Confirmar alteração de senha",
                loading: loading.value
              }, null, 8, ["loading"])
            ])
          ]),
          _: 2
        }, 1032, ["class"])
      ]),
      _: 1
    })
  ]))
}
}

})